/* eslint-disable padding-line-between-statements */
/* eslint-disable max-len */
import React, {
    useContext, useCallback, useEffect, useState, useRef
} from 'react';
import _ from 'lodash';
import appConfig from 'app-config';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { LoadSaveService, MLAccountSyncService, MLAddressVerificationService, Submission, Person, EmailValidationService, MLPortalSettingsService  } from 'gw-capability-quoteandbind';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { AvailabilityService } from 'gw-capability-policycommon';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { MLContactUtilsService } from 'ml-portals-services-js';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { MLMultiLobsDataHolderService, MLBundleService, MLHistoryService, MLClickToChatService } from 'ml-services-common-react';
import { SecondaryNamedInsuredComponent, MLPhoneNumberComponent, MLPolicyNamedInsuredCandidatesComponent } from 'ml-components-common-react';
import { platformMessages } from 'ml-components-platform-react';
import { MLQuoteNameUtil, MLProductCodeUtil, MLWizardUtil } from 'ml-portals-util-js';
import { MLPolicyTypeUtil, MLNotificationBlockUtil } from 'ml-portals-util-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import HOWizardConfig from '../../../gw-capability-quoteandbind-ho-react/config/ho-wizard-config.json5';
import PAWizardConfig from '../../../gw-capability-quoteandbind-pa-react/config/pa-wizard-config.json5';
import PUPWizardConfig from '../../../gw-capability-quoteandbind-pup-react/config/pup-wizard-config.json5';
import PrivacyPolicyComponent from '../../components/PrivacyPolicy/PrivacyPolicyComponent';
import PATrackEvent from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PATrackEvent';
import HOTrackEvent from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/HOTrackEvent';
import PUMBTrackEvent from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PUMBTrackEvent';


import metadata from './YourInfoPage.metadata.json5';
import messages from './YourInfoPage.messages';
import styles from './YourInfoPage.module.scss';
import { ScrollToError } from '@jutro/legacy/wizard-next';
import { ClausesUtil } from '@xengage/gw-policycommon-util-js';
import { ClauseService } from 'gw-capability-policycommon';
const BOOKROLL_WITH_RATE_CAPPING = 'with_Rate_Capping';
const BOOKROLL_WITHOUT_RATE_CAPPING = 'without_ratecapping';
const PERSONAL_AUTO = 'PersonalAuto';
const HOP_RENTAL = 'hoprental';
const HOP_HOMEOWNERS = 'HOPHomeowners';
const PERSONAL_UMBRELLA = 'PersonalUmbrella';
const stepNames = {
    [PERSONAL_AUTO]: ['paAccountSync', 'paGroupAssociations'],
    [HOP_HOMEOWNERS]: ['hoAccountSync', 'hoPrequalQuestions'],
    [PERSONAL_UMBRELLA]: ['pupAccountSync', 'pupPrequalQuestions']
};

function YourInfoPage(props) {
    const viewModelService = useContext(ViewModelServiceContext);
    const {
        wizardData: submissionVM,
        updateWizardData,
        steps,
        changeNextSteps,
        currentStep,
        isSkipping
    } = props;
    const { onValidate, isComponentValid } = useValidation('YourInfoPage');
    const { authHeader } = useAuthentication();
    const translator = useTranslator();
    const [showErrors, updateShowErrors] = useState(false);
    const [wasAnalyticsTriggered, updateWasAnalyticsTriggered] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [namedInsuredCandidatesML, updateNamedInsuredCandidatesML] = useState([]);
    const [questionSetSyncing, setQuestionSetSyncing] = useState(false);
    const [questionSetSyncPromise, setQuestionSetSyncPromise] = useState(null);
    const [ captchaEnabled, setCaptchaEnabled ] = useState(true);
    const [isModernProduct, setIsModernProduct] = useState(false);
    const [newProductStates, updateNewProductStates] = useState([]);
    const productCode = _.get(submissionVM, 'baseData.productCode.value');
    const isQuoteAndBuy = _.get(submissionVM, 'baseData.portalCode_ML.value') === 'QB';
    const isAlaska7Days = _.get(submissionVM, 'value.baseData.policyAddress.state') === 'AK' && _.get(submissionVM, 'value.baseData.termType') === '7Days';
    const secondaryNamedInsuredValue = _.get(submissionVM, 'baseData.secondaryNamedInsured_ML.value');
    const primaryNamedInsuredValue = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.value');
    const dateOfBirthRef = useRef(null)
    const periodStartDateRef = useRef(null)
    const firstNameRef = useRef(null);
    const lastNameRef = useRef(null);
    const emailRef = useRef(null);
    const state = _.get(submissionVM, 'value.baseData.policyAddress.state'); 
     const sniPriorMailingAddressValue = _.get(submissionVM, 'baseData.sniPriorAddressQuestion_Ext.value');
        const sniPriorAddress = _.get(submissionVM, 'baseData.sniPriorAddress_Ext');

    const { MLCustomHistoryTypes, captchaConfig, runtimeEnv } = appConfig;
    const captchaSiteKey = (runtimeEnv === 'prod') ? captchaConfig.siteKey_prod : captchaConfig.siteKey;
    const QUOTED_SUBMISSIONS_KEY = 'quotedSubmissionNumbers';

    const {
        getPolicyTypeName
    } = MLPolicyTypeUtil();

    const samePNIAndSNIAlertNameML = 'samePNIAndSNI';
    const {
        clearErrorAlerts,
        addErrorAlert,
        getNumberOfAlerts,
        clearBlockAlerts,
        addWarningAlert
    } = MLNotificationBlockUtil();

    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();

    const isQuoted = (quoteNumber) => {
        if (!quoteNumber) return false;
        const list = JSON.parse(localStorage.getItem(QUOTED_SUBMISSIONS_KEY) || '[]');
        return list.includes(quoteNumber);
    };

    let wizardSteps;
    if (productCode === PERSONAL_AUTO) {
        wizardSteps = PAWizardConfig.steps;
    } else if (productCode === HOP_HOMEOWNERS) {
        wizardSteps = HOWizardConfig.steps;
    } else {
        wizardSteps = PUPWizardConfig.steps;
    }

    if (!primaryNamedInsuredValue) {
        submissionVM.baseData.primaryNamedInsured_ML.value = submissionVM.baseData.accountHolder.value;
    }

    const isBookrollSubmission = (submission) => {
        return submission.bookrollInd_ML === BOOKROLL_WITH_RATE_CAPPING || submission.bookrollInd_ML === BOOKROLL_WITHOUT_RATE_CAPPING;
    };

    const generateAlaska7DaysError = (vm) => {
        const submission = vm.value;
        const baseData = submission.baseData;

        return {
            gwInfo: {
                params: [{
                    quoteID: submission.quoteID,
                    baseData: {
                        productCode: baseData.productCode,
                        termType: baseData.termType,
                        policyAddress: {
                            state: baseData.policyAddress.state
                        }
                    }
                }]
            }
        };
    };

    useEffect(() => {
        if (isBookrollSubmission(submissionVM.value)) {
            Promise.reject();
        } else if (!isQuoteAndBuy && submissionVM.hvqQuoteID_ML.value) {
            const quoteIndex = _.findIndex(
                steps,
                ({ path }) => path === '/quote'
            );
            const quoteSteps = steps.slice(quoteIndex, steps.length);
            const remainingSteps = steps.filter(item => quoteSteps.includes(item));
            changeNextSteps(remainingSteps);
        } else if (productCode === PERSONAL_AUTO && isAlaska7Days) {
            if ((submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value)) && !submissionVM.value.hasRateAsOfDateExpired()) {
                // go to quoteDetails
                const index = _.findIndex(
                    steps,
                    ({ path }) => path === '/quote'
                );
                if (index > 0) {
                    const remainingSteps = _.slice(steps, index);
                    changeNextSteps(remainingSteps);
                }
            } else {
                const error = generateAlaska7DaysError(submissionVM);
                Promise.reject(error);
            }
        }

        MLPortalSettingsService.getSettings(authHeader).then((response) => {
            setCaptchaEnabled(response.enableCaptcha)
            if(response){
                updateNewProductStates(response.enableAuto50ProductStates);
            }
        });

        if (document.getElementsByName('firstName').length > 0) {
            setTimeout(() => { document.getElementsByName('firstName')[0].focus()}, 100);
        }

        if (submissionVM.quoteID?.value) {
            sessionStorage.setItem('quoteID', submissionVM.quoteID?.value);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const skipOnResumeIf = () => {
        if (!!_.get(submissionVM, 'bindData.policyNumber.value')
            && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
            return true;
        }

        if (productCode === PERSONAL_AUTO && isAlaska7Days) {
            return true;
        }

        if (isBookrollSubmission(submissionVM.value)) {
            return true;
        }

        if ((MLMultiLobsDataHolderService.getLastVisitedStep() === undefined
            || MLMultiLobsDataHolderService.getLastVisitedStep() === currentStep.mlStepName)
            && (!submissionVM.value.hvqQuoteID_ML || !submissionVM.baseData.primaryNamedInsured_ML.emailAddress1.value)) {
            return false;
        }

        if (productCode === PERSONAL_AUTO || productCode === HOP_HOMEOWNERS) {
            if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'quoteDetails' &&
                submissionVM.hvqQuoteID_ML.value &&
                submissionVM.isBundle_ML.value) {
                return true;
            }
        }

        return true;
    };

    const validateData = useCallback(() => {
        if (!isComponentValid) {
            updateShowErrors(true);
            setTimeout(() => {
                setErrorTimestamp(errorTimestamp + 1);
            }, 500);
            return false;
        }

        if(isQuoteAndBuy && !_.get(submissionVM, 'baseData.primaryNamedInsured_ML.homeNumber.value')) {
            updateShowErrors(true);
            setTimeout(() => {
                setErrorTimestamp(errorTimestamp + 1);
            }, 500);
            return false;
        }
           
        _.set(submissionVM, 'baseData.bypassCreditOrdering_Ext.value', false);

        if (!submissionVM.aspects.valid || !submissionVM.aspects.subtreeValid || getNumberOfAlerts(samePNIAndSNIAlertNameML) > 0) {
            updateShowErrors(true);
            setTimeout(() => {
                setErrorTimestamp(errorTimestamp + 1);
            }, 500);
            window.scrollTo(0, 0);
            return false;
        }

        return true;
    }, [authHeader, currentStep.mlStepName, errorTimestamp, getNumberOfAlerts, isComponentValid, submissionVM]);

    const loadNamedInsuredCandidatesML = useCallback(() => {
        if (submissionVM.baseData.accountNumber.value) {
            const namedInsuredCandidatesPromise = LoadSaveService.getNamedInsuredCandidatesML(
                submissionVM.baseData.accountNumber.value,
                submissionVM.baseData.productCode.value,
                authHeader
            );
            if (!isSkipping || (isSkipping && !skipOnResumeIf())) {
                showProgressDialog(platformMessages.loading, namedInsuredCandidatesPromise, true);
            }
            namedInsuredCandidatesPromise
                .then((candidates) => {
                    if (candidates && candidates.length > 0) {
                        const candidatesObjectArr = candidates.map((candidate) => viewModelService.create(Person.createFromAccountContact(candidate), 'pc',
                            'edge.capabilities.policycommon.accountcontact.dto.AccountContactDTO'));
                        const candidatesVM = candidatesObjectArr.map((candidateVM) => candidateVM.value);
                        updateNamedInsuredCandidatesML([...candidatesVM]);
                        if (isQuoteAndBuy && primaryNamedInsuredValue && (!primaryNamedInsuredValue?.homeNumber || !primaryNamedInsuredValue?.subtype)) {
                            submissionVM.baseData.primaryNamedInsured_ML.homeNumber = candidatesVM[0].homeNumber;
                            submissionVM.baseData.primaryNamedInsured_ML.subtype = candidatesVM[0].subtype;
                            updateWizardData(submissionVM)
                        }
                    }
                })
                .catch(() => {
                    updateNamedInsuredCandidatesML([]);
                });
        } else {
            updateNamedInsuredCandidatesML([]);
        }
    }, [authHeader, showProgressDialog, submissionVM, viewModelService]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        _.set(submissionVM, 'baseData.portalCode_ML.value', appConfig.portalCode);
        loadNamedInsuredCandidatesML();
        if (productCode === PERSONAL_AUTO) {
            submissionVM.baseData.termType = 'HalfYear';
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(isQuoteAndBuy && submissionVM?.hvqQuoteID_ML?.value) {
            window.dataLayer = window.dataLayer || []; window.dataLayer.push({'event': 'IsBindable',});
        }
    }, []);

    useEffect(() => {
            if (newProductStates.includes(submissionVM.baseData.policyAddress.state.value.code)) {
                setIsModernProduct(true);
            } else {
                setIsModernProduct(false);
            }
        }, [newProductStates]);



    const coverageType = _.get(submissionVM, 'lobData.homeowners.coverables.coveragePartType_ML.value.code', undefined);

    const secondaryNamedInsured = _.get(submissionVM, 'baseData.secondaryNamedInsured_ML.value');
    const samePhoneAsPrimaryNamedInsured = useCallback(() => {
        const secondaryInsuredHomeNumber = _.get(submissionVM, 'baseData.secondaryNamedInsured_ML.homeNumber.value');
        const primaryNamedInsuredHomeNumber = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.homeNumber.value');
        if (secondaryNamedInsured) {
            return secondaryInsuredHomeNumber === primaryNamedInsuredHomeNumber;
        }
        return true;
    }, [secondaryNamedInsured, submissionVM]);

    const [samePhone, setSamePhone] = useState(samePhoneAsPrimaryNamedInsured);

    const sameMailingAddressValue = _.get(submissionVM, 'baseData.sameMailingAddress_ML.value');
    const mailingAddress = _.get(submissionVM, 'baseData.mailingAddress_ML');
    const changeMailingAddressValue = _.get(submissionVM, 'baseData.changeMailingAddQuestion_Ext.value');
    const priorMailingAddressValue = _.get(submissionVM, 'baseData.priorAddressQuestion_Ext.value');
    const priorAddress = _.get(submissionVM, 'baseData.priorAddress_Ext');
    const policyAddress = _.get(submissionVM, 'baseData.policyAddress');

    const createNewAddress = () => {
        const policyAddressValue = policyAddress.value;
        const addressObj = {
            displayName: policyAddressValue.displayName,
            state: policyAddressValue.state,
            city: policyAddressValue.city,
            postalCode: policyAddressValue.postalCode,
            country: policyAddressValue.country,
            addressLine1: policyAddressValue.addressLine1,
            addressLine2: policyAddressValue.addressLine2
        };
        return viewModelService.create(addressObj, 'pc', 'edge.capabilities.address.dto.AddressDTO');
    };

    const syncAddresses = (fromAddress, toAddress) => {
        _.set(toAddress, 'addressLine1', fromAddress.addressLine1);
        _.set(toAddress, 'addressLine2', fromAddress.addressLine2);
        _.set(toAddress, 'city', fromAddress.city);
        _.set(toAddress, 'state', fromAddress.state);
        _.set(toAddress, 'postalCode', fromAddress.postalCode);
        _.set(toAddress, 'country', fromAddress.country);
        _.set(toAddress, 'displayName', fromAddress.displayName);
    };

    useEffect(() => {
        // skip yourInfoPage in Qnb for HVQ Quote
        if (submissionVM.hvqQuoteID_ML.value) {
            return;
        }

        if (!isSkipping || (isSkipping && !skipOnResumeIf())) {
            if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                HOTrackEvent('Quote Step Reached', isSkipping, submissionVM, null, { step: 'Your Info Page' }, true);
            } else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                PUMBTrackEvent('Quote Step Reached', isSkipping, submissionVM, null, { step: 'Your Info Page' }, true);
            } else {
                PATrackEvent('Quote Step Reached', isSkipping, submissionVM, null, { step: 'Your Info Page' }, true);
            }

            const clonedSubmissionVM = _.clone(submissionVM);
            if (MLProductCodeUtil.isHomeOwners(productCode) && _.isUndefined(clonedSubmissionVM.lobData.homeowners.coverables.policyAddress.value)) {
                const newPolicyAddress = createNewAddress();
                _.set(clonedSubmissionVM, 'lobData.homeowners.coverables.policyAddress.value', newPolicyAddress.value);
            }

            if (_.isUndefined(sameMailingAddressValue)) {
                _.set(clonedSubmissionVM, 'baseData.sameMailingAddress_ML.value', true);
            }

            if (_.isUndefined(mailingAddress.value)) {
                const newMailingAddress = createNewAddress();
                _.set(clonedSubmissionVM, 'baseData.mailingAddress_ML.value', newMailingAddress.value);
            }

            if (_.isUndefined(priorMailingAddressValue)) {
                _.set(clonedSubmissionVM, 'baseData.priorAddressQuestion_Ext.value', false);
            }
            if (_.isUndefined(sniPriorMailingAddressValue)) {
                _.set(clonedSubmissionVM, 'baseData.sniPriorAddressQuestion_Ext.value', false);
            }
            if (priorAddress.value && priorAddress.value.postalCode) {
                _.set(clonedSubmissionVM, 'baseData.priorAddress_Ext.value', priorAddress.value);
            } else {
                priorAddress.value = {
                    addressLine1: policyAddress.addressLine1.value,
                    addressLine2: policyAddress.addressLine2.value,
                    displayName: policyAddress.displayName.value,
                    state: policyAddress.state.value.code,
                    city: policyAddress.city.value,
                    postalCode: policyAddress.postalCode.value,
                    country: policyAddress.country.value.code
                };
            }
            if (sniPriorAddress.value && sniPriorAddress.value.postalCode) {
                _.set(clonedSubmissionVM, 'baseData.sniPriorAddress_Ext.value', sniPriorAddress.value);
            } else {
                sniPriorAddress.value = {
                    addressLine1: policyAddress.addressLine1.value,
                    addressLine2: policyAddress.addressLine2.value,
                    displayName: policyAddress.displayName.value,
                    state: policyAddress.state.value.code,
                    city: policyAddress.city.value,
                    postalCode: policyAddress.postalCode.value,
                    country: policyAddress.country.value.code
                };
            }

            _.set(clonedSubmissionVM, 'isSubmitAgent.value', false);
            _.set(clonedSubmissionVM, 'baseData.primaryNamedInsured_ML.isHomeNumReq.value', true);
            if (_.isUndefined(clonedSubmissionVM.isBundle_ML.value)) {
                if (MLBundleService.getJobsToCreate().length > 1) {
                    _.set(clonedSubmissionVM, 'isBundle_ML.value', true);
                }
            }
            updateWizardData(clonedSubmissionVM);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        // skip yourInfoPage in Qnb for HVQ Quote
        if (submissionVM.hvqQuoteID_ML.value) {
            return;
        }

        const clonedSubmissionVM = _.clone(submissionVM);

        if (productCode === HOP_HOMEOWNERS) {
            syncAddresses(policyAddress, clonedSubmissionVM.lobData.homeowners.coverables.policyAddress);
        }

        if (sameMailingAddressValue) {
            syncAddresses(policyAddress, clonedSubmissionVM.baseData.mailingAddress_ML);
        }

        if (!priorMailingAddressValue) {
            syncAddresses(policyAddress, clonedSubmissionVM.baseData.priorAddress_Ext);
        }
        if (!sniPriorMailingAddressValue) {
            syncAddresses(policyAddress, clonedSubmissionVM.baseData.sniPriorAddress_Ext);
        }
        updateWizardData(clonedSubmissionVM);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [policyAddress]);

    const updateSubmissionVM = useCallback(() => {
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    // show error alert when PNI and SNI are the same contact
    useEffect(() => {
        clearErrorAlerts();
        if (primaryNamedInsuredValue && primaryNamedInsuredValue.publicID &&
            secondaryNamedInsuredValue && secondaryNamedInsuredValue.publicID &&
            primaryNamedInsuredValue.publicID === secondaryNamedInsuredValue.publicID) {
            addErrorAlert(messages.SNIAndPNICannotBeTheSameContactML, samePNIAndSNIAlertNameML);
            window.scrollTo(0, 0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [primaryNamedInsuredValue, secondaryNamedInsuredValue]);
    
    useEffect(() => {
    if (!isQuoteAndBuy) return;
      const current = _.get(submissionVM, "baseData.periodStartDate.value");
      const userModified = _.get(
        submissionVM,
        "baseData.periodStartDateUserModified",
      );

      if (!current || userModified) return;

      const target = new Date();
      target.setHours(0, 0, 0, 0);
      target.setDate(target.getDate() + 8);

      const currentJsDate = new Date(current.year, current.month, current.day);
      currentJsDate.setHours(0, 0, 0, 0);

      if (currentJsDate < target) {
        const newSubmissionVM = viewModelService.clone(submissionVM);

        _.set(newSubmissionVM, "baseData.periodStartDate.value", {
          day: target.getDate(),
          month: target.getMonth(),
          year: target.getFullYear(),
        });

        updateWizardData(newSubmissionVM);
      }
    }, [submissionVM, updateWizardData, viewModelService]);

    const writeValue = useCallback((value, path) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        if (
        path === 'baseData.periodStartDate' ||
        path === 'baseData.periodStartDate.value'
    ) {
        _.set(newSubmissionVM, 'baseData.periodStartDateUserModified', true);
    }
        _.set(newSubmissionVM, path, value);
        updateWizardData(newSubmissionVM);
    }, [submissionVM, updateWizardData, viewModelService]);

    // used to set the SNI address if the SNI is added before the PNI
    const writeAddressValueML = useCallback((value, path) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, path, value);
        if (secondaryNamedInsured && !secondaryNamedInsured.primaryAddress.addressLine1) {
            _.set(newSubmissionVM, 'baseData.secondaryNamedInsured_ML.primaryAddress.value', value);
        }
        updateWizardData(newSubmissionVM);
    }, [secondaryNamedInsured, submissionVM, updateWizardData, viewModelService]);

    const uppercaseContactName = (contact) => {
        _.set(contact, 'firstName', _.toUpper(contact.firstName));
        _.set(contact, 'firstNameKanji', _.upperCase(contact.firstNameKanji));
        _.set(contact, 'lastName',_.toUpper(contact.lastName));
        _.set(contact, 'lastNameKanji', _.upperCase(contact.lastNameKanji));
        _.set(contact, 'middleName', _.upperCase(contact.middleName));
    };

    const uppercaseNames = useCallback(() => {
        const primaryNamedInsured = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.value');
        uppercaseContactName(primaryNamedInsured);

        if (secondaryNamedInsured) {
            uppercaseContactName(secondaryNamedInsured);
        }
    }, [secondaryNamedInsured, submissionVM]);

    const setDefaultPrimaryPhone = useCallback(() => {
        MLContactUtilsService.setDefaultPrimaryPhone(submissionVM.baseData.primaryNamedInsured_ML);

        if (secondaryNamedInsured && samePhone) {
            _.set(submissionVM, 'baseData.secondaryNamedInsured_ML.primaryPhoneType', submissionVM.baseData.primaryNamedInsured_ML.primaryPhoneType);
        }
    }, [samePhone, secondaryNamedInsured, submissionVM]);

    const checkAvailability = useCallback((productType) => {
        const localDate = submissionVM.baseData.periodStartDate.value;
        const postalCode = _.get(submissionVM, 'baseData.policyAddress.postalCode.value');
        const state = _.get(submissionVM, 'baseData.policyAddress.state.value');
        const availabilityDto = {
            effectiveDate: localDate,
            productCode: productType,
            postalCode: postalCode.substring(0, 5),
            coveragePartType_ML: coverageType,
            stateCode_ML: state.code
        };
        return AvailabilityService.productAvailableBasedOnPostalCode(availabilityDto);
    }, [coverageType, submissionVM]);

    const setCurrentStepName = useCallback(() => {
        if (MLProductCodeUtil.isPersonalAuto(productCode)) {
            _.set(submissionVM, 'portalCurrentStep_ML.value', 'paContactDetails');
        } else if (MLProductCodeUtil.isHomeOwners(productCode)) {
            _.set(submissionVM, 'portalCurrentStep_ML.value', 'hoContactDetails');
        } else if (MLProductCodeUtil.isPersonalUmbrella(productCode)) {
            _.set(submissionVM, 'portalCurrentStep_ML.value', 'pupContactDetails');
        }
    }, [productCode, submissionVM]);

    const setCurrentStepName2 = (sub) => {
        if (MLProductCodeUtil.isPersonalAuto(sub.baseData.productCode.value)) {
            sub.portalCurrentStep_ML.value = 'paContactDetails';
        } else if (MLProductCodeUtil.isHomeOwners(sub.baseData.productCode.value)) {
            sub.portalCurrentStep_ML.value = 'hoContactDetails';
        } else if (MLProductCodeUtil.isPersonalUmbrella(sub.baseData.productCode.value)) {
            sub.portalCurrentStep_ML.value = 'pupContactDetails';
        }
    };

    const initAddresses = (lob, pAddress, sub) => {
        if (lob === 'HOPHomeowners') {
            sub.lobData.homeowners.coverables.policyAddress.value = sub.lobData.homeowners.coverables.policyAddress.value || {
                displayName: pAddress.displayName,
                state: pAddress.state,
                city: pAddress.city,
                postalCode: pAddress.postalCode,
                country: pAddress.country,
                addressLine1: pAddress.addressLine1,
                addressLine2: pAddress.addressLine2
            };
        }

        if (!sub.baseData.sameMailingAddress_ML.value) {
            sub.baseData.sameMailingAddress_ML.value = true;
        }

        sub.baseData.mailingAddress_ML.value = sub.baseData.mailingAddress_ML.value || {
            displayName: pAddress.displayName,
            state: pAddress.state,
            city: pAddress.city,
            postalCode: pAddress.postalCode,
            country: pAddress.country,
            addressLine1: pAddress.addressLine1,
            addressLine2: pAddress.addressLine2
        };

        if (_.isUndefined(sub.baseData.priorAddressQuestion_Ext.value)) {
            sub.baseData.priorAddressQuestion_Ext.value = false;
        }

        sub.baseData.priorAddress_Ext.value = sub.baseData.priorAddress_Ext.value || {
            displayName: pAddress.displayName,
            state: pAddress.state,
            city: pAddress.city,
            postalCode: pAddress.postalCode,
            country: pAddress.country,
            addressLine1: pAddress.addressLine1,
            addressLine2: pAddress.addressLine2
        };
        if (_.isUndefined(sub.baseData.sniPriorAddressQuestion_Ext.value)) {
            sub.baseData.sniPriorAddressQuestion_Ext.value = false;
        }

        sub.baseData.sniPriorAddress_Ext.value = sub.baseData.sniPriorAddress_Ext.value || {
            displayName: pAddress.displayName,
            state: pAddress.state,
            city: pAddress.city,
            postalCode: pAddress.postalCode,
            country: pAddress.country,
            addressLine1: pAddress.addressLine1,
            addressLine2: pAddress.addressLine2
        };
    };

    const retrieveSubmissionVM = (qdd) => {
        return LoadSaveService.getJobData(qdd.sessionUUID, qdd.quoteID);
    };

    const createBundleSubmissions = useCallback(() => {
        const copiedSubs = MLBundleService.getJobsToCreate().map((job) => {
            const copiedSub = viewModelService.clone(submissionVM);
            copiedSub.value.baseData.productCode = job.productCode;
            if (job.productCode === 'HOPHomeowners') {
                if (_.isUndefined(copiedSub.lobData.value)) {
                    copiedSub.lobData.value = {};
                }
                copiedSub.lobData.homeowners.value = {};
                copiedSub.lobData.homeowners.coverables.value = {
                    coveragePartType_ML: job.productType
                };
            }
            // used for IMF
            setCurrentStepName2(copiedSub);
            // need to copy policy address into homeowners policy address
            initAddresses(copiedSub.baseData.productCode.value, copiedSub.baseData.policyAddress.value, copiedSub);
            return copiedSub.value;
        });
        return MLBundleService.createBundleSubmissions(copiedSubs);
    }, [submissionVM, viewModelService]);

    const _leadStartEvent = useCallback(() => {
        const attributes = { form: MLTagManagerService.getFormName() };
        if (submissionVM.isBundle_ML.value && MLBundleService.getJobsToCreate().length > 1) {
            attributes.bundleChoose = MLBundleService.getJobsToCreate().map((job) => MLTagManagerService.getPolicyTypeName(job.productCode)).join('|');
        }
        MLTagManagerService.sendEvent('leadStart', attributes);
        updateWasAnalyticsTriggered(true);
    }, [submissionVM.isBundle_ML.value]);

    const sendSubmissionCreatedEvent = (subVM) => {
        if (!_.isUndefined(subVM.quoteID.value)) {
            const request = {
                jobNumber: subVM.quoteID.value,
                sessionUUID: subVM.sessionUUID.value,
                eventType: MLCustomHistoryTypes.SubmissionCreated
            };
            MLHistoryService.createHistoryEvents([request]);
        }
    };

    const createPayloadToSyncQuestionSet = () => {
        let question;
        //populating true if user didnt ans the question
        let userResponse = "true";

        // Remove if privacy question is not added to Your Info page
        /*if(farmersPrivacyNoticeValue === undefined || farmersPrivacyNoticeValue === null){
            userResponse = "true";
        }else{
            userResponse = farmersPrivacyNoticeValue;
        }*/


        if (submissionVM.baseData.productCode.value === "PersonalAuto") {
            _.set(submissionVM, "lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext", userResponse)
            question = _.get(submissionVM, "lobData.personalAuto.questionSets_ML.value.privacyDisclaimer");
        } else if (submissionVM.baseData.productCode.value === "PersonalUmbrella") {
            _.set(submissionVM, 'lobData.personalUmbrella.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext', userResponse);
            question = _.get(submissionVM, "lobData.personalUmbrella.value.privacyDisclaimer[0]");
        } else if (submissionVM.baseData.productCode.value === "HOPHomeowners") {
            _.set(submissionVM, 'lobData.homeowners.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext', userResponse);
            question = _.get(submissionVM, "lobData.homeowners.value.privacyDisclaimer[0]");
        }

        return question;
    }

    const showFarmersPrivacyNoticerValue = () => {
        return submissionVM.baseData.productCode.value === "PersonalAuto" || submissionVM.baseData.productCode.value === "PersonalUmbrella" || 
        (submissionVM.baseData.productCode.value === "HOPHomeowners" && isModernProduct);
    }

    const checkQuestionSetSync = (serviceCall) => {
        let updatePromise;
        if (questionSetSyncing && questionSetSyncPromise) {
            updatePromise = questionSetSyncPromise.then(() => {
                const promise = serviceCall();
                setTimeout(() => {
                    showProgressDialog(platformMessages.syncingQuestions, promise, true);
                }, 0);
                return promise;
            });
        } else {
            updatePromise = serviceCall();
            setTimeout(() => {
                showProgressDialog(platformMessages.syncingQuestions, updatePromise, true);
            }, 100);
        }
        setQuestionSetSyncing(true);
        setQuestionSetSyncPromise(updatePromise);
        return updatePromise;
    };

    const syncQuestionSets = async () => {
        const aQuestionSetAnswersValue = createPayloadToSyncQuestionSet();
        const { code } = aQuestionSetAnswersValue;
        const quoteID = submissionVM.quoteID.value;

        const transformedQuestions = {};
        if (code && code === "PrivacyDisclaimer_ML") {
            if (code && code === "PrivacyDisclaimer_ML") {
                setQuestionSetSyncing(true); // show loading state

                try {
                    const updatedQuestions = await checkQuestionSetSync(() =>
                        LoadSaveService.syncQuestionSetML(quoteID, [aQuestionSetAnswersValue], authHeader)
                    );

                    const newVm = viewModelService.clone(submissionVM);

                    updatedQuestions.forEach((q) => {
                        transformedQuestions[q.code] = q;
                    });

                    if (code === "PrivacyDisclaimer_ML") {
                        if (submissionVM.baseData.productCode.value === "PersonalAuto") {
                            _.set(newVm, 'lobData.personalAuto.value.questionSets_ML.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext', transformedQuestions.PrivacyDisclaimer_ML.answers.FarmersPrivacyNotice_Ext);
                        } else if (submissionVM.baseData.productCode.value === "PersonalUmbrella") {
                            _.set(newVm, 'lobData.personalUmbrella.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext', transformedQuestions.PrivacyDisclaimer_ML.answers.FarmersPrivacyNotice_Ext);
                        } else if (submissionVM.baseData.productCode.value === "HOPHomeowners") {
                            _.set(newVm, 'lobData.homeowners.value.privacyDisclaimer[0].answers.FarmersPrivacyNotice_Ext', transformedQuestions.PrivacyDisclaimer_ML.answers.FarmersPrivacyNotice_Ext);
                        }
                    }
                    updateWizardData(newVm);
                } catch (error) {
                    console.error("Error syncing question set:", error);
                } finally {
                    setQuestionSetSyncPromise(null);
                    setQuestionSetSyncing(false);
                }
            }
        }
    };

    const executeRecaptcha = async () => {
        try {
            const token = await new Promise((resolve, reject) => {
                grecaptcha.enterprise.ready(async () => {
                    try {
                        const recaptchaToken = await grecaptcha.enterprise.execute(
                            captchaSiteKey
                        );
                        resolve(recaptchaToken);
                    } catch (error) {
                        reject(error);
                    }
                });
            });

            return token;
        } catch (err) {
            console.error("CAPTCHA Execution Failed:", err);
        }
    };
    
    const checkErrorFocus = () => {
        const phoneNumber = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.homeNumber.value')
        const address = _.get(submissionVM, 'baseData.policyAddress.validateAddressStatus_ML.value')

        if (!firstNameRef.current.valid) {
            setTimeout(() => { 
                document.getElementsByName('firstName')[0].focus()
            }, 100);
        } else if (!lastNameRef.current.valid) {
            setTimeout(() => { 
                document.getElementsByName('lastName')[0].focus()
            }, 100);
        } else if (!dateOfBirthRef.current.valid) {
            setTimeout(() => {
                document.querySelector('[data-testid="dateOfBirth"]')?.focus();
            }, 100);
        } else if (!emailRef.current.valid) {
            setTimeout(() => { 
                document.getElementsByName('emailAddress')[0].focus()
            }, 100);
        } else if (phoneNumber === undefined || phoneNumber?.length < 10) {
            setTimeout(() => { 
                document.querySelector('input[id*="phoneNumber_"]').focus()
            }, 100);
        } else if (address === undefined) {
            setTimeout(() => { 
                // eslint-disable-next-line no-secrets/no-secrets
                document.querySelector('input[id*="addresslookupSearch_"]').focus()
            }, 100);
        }
    }

    const onNext = useCallback(async () => {
        if(isQuoteAndBuy) {
            checkErrorFocus();
        }

        if (!wasAnalyticsTriggered) {
            _leadStartEvent();
        }
        setCurrentStepName();

        if (submissionVM.baseData.primaryNamedInsured_ML.publicID.value === submissionVM.baseData.accountHolder.publicID.value) {
            submissionVM.baseData.accountHolder.value = submissionVM.baseData.primaryNamedInsured_ML.value;
            if(!submissionVM.baseData.accountHolder.subtype.value) {
                submissionVM.baseData.accountHolder.subtype.value = 'Person';
            }
        }

        // Validating the Data before Validating the address
        try {
            const isDataValid = await validateData();
            if (!isDataValid) {
                return false;
            }
        } catch (e) {
            updateShowErrors(true);
            setTimeout(() => {
                setErrorTimestamp(errorTimestamp + 1);
            }, 500);
            return false;
        }

        const validateAddressStatus = _.get(submissionVM, 'baseData.policyAddress.validateAddressStatus_ML.value');

        if (_.isUndefined(validateAddressStatus) || validateAddressStatus === false) {
            try {
                await MLAddressVerificationService.validateAddress(viewModelService, policyAddress, productCode);
            } catch (err) {
                return false;
            }
        }

         _.set(submissionVM, 'baseData.bypassCreditOrdering_Ext.value', false);
         
        if (submissionVM.value.isQuoted() && isQuoteAndBuy) {
            const mailID = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.emailAddress1.value');
            _.set(submissionVM, 'bindData.actionRequiredDocuments_ML[0].recipientEmail_Ext.value', mailID)
        }

        if (!submissionVM.aspects.valid || !submissionVM.aspects.subtreeValid || getNumberOfAlerts(samePNIAndSNIAlertNameML) > 0) {
            updateShowErrors(true);
            setErrorTimestamp(errorTimestamp + 1);
            window.scrollTo(0, 0);
            return false;
        }

        setDefaultPrimaryPhone();
        uppercaseNames();

        if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
            HOTrackEvent('Quote Step Submitted', isSkipping, submissionVM, null, { step: 'Your Info Page' }, true);
        } else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
            PUMBTrackEvent('Quote Step Submitted', isSkipping, submissionVM, null, { step: 'Your Info Page' }, true);
        } else {
            PATrackEvent('Quote Step Submitted', isSkipping, submissionVM, null, { step: 'Your Info Page' }, true);
        }

        if(sessionStorage.getItem('IsBundle')){
            sessionStorage.removeItem('IsBundle');
        }

        try {
            let progressMessage = platformMessages.OneMomentPlease;
            if (submissionVM.isBundle_ML.value && MLBundleService.getJobsToCreate().length > 1) {
                progressMessage = MLBundleService.getCreationProgressMessage(getPolicyTypeName);
            }
            showProgressDialog(progressMessage);
            const response = await checkAvailability(productCode);

            if (!response.isAvailable) {
                const productName = productCode === HOP_HOMEOWNERS ? MLQuoteNameUtil.getCoveragePartTypeName(coverageType) : MLQuoteNameUtil.getProductName(productCode);
                const phone = translator(messages.mlPhoneNumber);
                hideProgressDialog();
               showErrorModal(
                 "",
                 <FormattedMessage
                   {...messages.productNotAvailable}
                   values={{
                     product: productName,
                     phoneNum: (
                       <a
                         href={`tel:${phone}`}
                         style={{ textDecoration: "none" }}
                       >
                         {phone}
                       </a>
                     ),
                   }}
                 />,
                 messages.closeWindow,
               );
                return false;
            }

            _.unset(submissionVM.value, 'bindData');

            let nextStepName;
            const [accountSyncStepName, affiliationStepName] = stepNames[productCode];

            if (submissionVM.isBundle_ML.value && MLBundleService.getJobsToCreate().length > 1) {
                const qdd = await createBundleSubmissions();
                console.info(qdd);
                const subModel = await retrieveSubmissionVM(qdd);
                console.info(subModel);
                const sub = new Submission(subModel);
                const subVM = viewModelService.create(sub, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO');
                MLBundleService.resetJobsToCreate();
                MLBundleService.setSessionUUID(subVM.sessionUUID.value);
                MLBundleService.refreshBundleSummary(subVM.baseData.accountNumber.value);
                _.set(submissionVM, 'value', subModel);
                setCurrentStepName();
            }

            sendSubmissionCreatedEvent(submissionVM);

            if (productCode === PERSONAL_AUTO && !!submissionVM.hvqQuoteID_ML.value && !isQuoteAndBuy) {
                if (!MLMultiLobsDataHolderService.hasCompletedStep('paAccountSync')) {
                    nextStepName = accountSyncStepName;
                } else {
                    const nextDefaultFieldsStep = MLMultiLobsDataHolderService.getFirstHVQConsumerNonCompletedStep();
                    const hasPendingDefaultFieldPages = nextDefaultFieldsStep !== null;

                    if (hasPendingDefaultFieldPages &&
                        MLMultiLobsDataHolderService.hasCompletedStep('paHVQConsumerPrefillAndCarfax')) {
                        const index = _.findIndex(
                            steps,
                            ({ path }) => path === '/pa-hvq-steps'
                        );
                        if (index > 0) {
                            const remainingSteps = steps.slice(index, steps.length);
                            changeNextSteps(remainingSteps);
                        }
                        nextStepName = 'paHVQConsumerDiscrepanciesCheck';
                    } else {
                        showProgressDialog(platformMessages.saveAndQuoteSubmission);
                        const submissionResponse = await LoadSaveService.saveAndQuoteSubmission(submissionVM.value);
                        submissionVM.value = submissionResponse;
                        hideProgressDialog();

                        const index = _.findIndex(
                            steps,
                            ({ path }) => path === '/quote'
                        );
                        if (index > 0) {
                            const remainingSteps = steps.slice(index, steps.length);

                            // filter out PAAdditionalInformationPreBindPage from wizard progress bar, added PAHVQAdditionalInformationPreBindPage
                            const filteredRemainingSteps = remainingSteps.filter((item) => {
                                return item.path !== '/additional-information-prebind';
                            });
                            changeNextSteps(filteredRemainingSteps);
                        }
                        nextStepName = 'quoteDetails';
                    }
                }
            } else if ((!!submissionVM.baseData.accountNumber.value || !submissionVM.baseData.accountHolder.accountInSync_ML.value)
                && !((submissionVM.hvqQuoteID_ML.value && !isQuoteAndBuy) && !submissionVM.isSubmitAgent.value)) {

                if (!submissionVM.quoteID.value) {
                    let headers = [];
                    if (captchaEnabled) {
                        const token  = await executeRecaptcha();

                        headers = {
                            'x-captcha': token
                        }
                    }

                    showProgressDialog(platformMessages.settingThingsUp);

                     /*US1079561: A360 consumer Q&B - FFQ redirection URL - additional query parameters*/
                    if (!_.isEmpty(sessionStorage.getItem('ffqQuoteNumber'))) {
                        const ffqQuoteNumber = sessionStorage.getItem('ffqQuoteNumber');
                        _.set(submissionVM, 'baseData.ffqquoteNumber_Ext.value', ffqQuoteNumber);
                    }
                    if (!_.isEmpty(sessionStorage.getItem('sourceId'))) {
                        const sourceId = sessionStorage.getItem('sourceId');
                        _.set(submissionVM, 'baseData.directConsumerSource_Ext.value', sourceId);
                    }

                    const submissionData = await LoadSaveService.createSubmission(submissionVM.value, headers);

                    _.set(submissionVM, 'value', submissionData);

                    if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                        //Due to bundle issues in PC, trampoline ind is not always set by Nearmap as it should be
                        const trampolineInd = submissionVM.lobData.homeowners.coverables?.constructionDetails_ML?.aerialImageryTrampolineInd_Ext?.value
                        if (trampolineInd && trampolineInd.code === 'Yes') {
                                submissionVM.lobData.homeowners.dwellingAdditionalInfo.value[0].answers.HOPHasTrampoline_ML = 'true';
                        }

                        HOTrackEvent('Quote Started', false, submissionVM, null, { step: 'Your Info Page' }, true);
                    } else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                        PUMBTrackEvent('Quote Started', false, submissionVM, null, { step: 'Your Info Page' }, true);
                    } else {
                        PATrackEvent('Quote Started', false, submissionVM, null, { step: 'Your Info Page' }, true);
                    }

                    try {
                        window.analytics.identify( 
                            {
                                qnb_quote_id: submissionVM.quoteID?.value,
                                email: submissionVM.baseData.primaryNamedInsured_ML?.emailAddress1?.value,
                                phone_number: submissionVM.baseData.primaryNamedInsured_ML?.homeNumber?.value
                            }
                        )
                    } catch (e) {
                        console.error(`Error calling Segment Identify API ${e.message}`);
                    }

                    sessionStorage.setItem('quoteID', submissionVM.quoteID?.value);

                    if (showFarmersPrivacyNoticerValue()) {
                        await syncQuestionSets();
                        //lock the question and make it readonly
                        // const jsonData = {  alreadyVisited: true };
                        // MLPortalStorageService.store(submissionVM.quoteID.value, null, ML_STORAGE_KEY_ALREADY_VISITED, JSON.stringify(jsonData), authHeader);
                    }

                    ClausesUtil.getDependentClausesFromServer(
                        ClauseService,
                        _.get(submissionData, 'quoteID'),
                        authHeader
                    );

                } else {
                    showProgressDialog(platformMessages.settingThingsUp);
                    const submissionData = await LoadSaveService.updateDraftSubmission(submissionVM.value);
                    _.set(submissionVM, 'value', submissionData);

                    if(isQuoteAndBuy && submissionVM?.isBundle_ML) {
                        if (submissionVM?.baseData?.productCode?.value === 'HOPHomeowners') {
                            HOTrackEvent('Quote Started', false, submissionVM, null, { step: 'Your Info Page' }, true);
                        }
                        else {
                            PATrackEvent('Quote Started', false, submissionVM, null, { step: 'Your Info Page' }, true);
                        }
                    }
                    
                    try {
                        window.analytics.identify(
                            {
                                qnb_quote_id: submissionVM.quoteID?.value,
                                email: submissionVM.baseData.primaryNamedInsured_ML?.emailAddress1?.value,
                                phone_number: submissionVM.baseData.primaryNamedInsured_ML?.homeNumber?.value
                            }
                        )
                    } catch (e) {
                        console.error(`Error calling Segment Identify API ${e.message}`);
                    }
                }

                _.unset(submissionVM.value, 'bindData');
                nextStepName = affiliationStepName;
            } else {
                nextStepName = accountSyncStepName;
            }
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, nextStepName);

            return submissionVM;
        } catch (err) {
            console.error(err);
            if (err.baseError && err.baseError.includes('INVALID_PARAM')) {
                return false;
            } else if (err.baseError && (err.baseError.includes('Captcha') || err.baseError.includes('InstantID'))) {
                throw err;
            }
            hideProgressDialog();
            showErrorModal('', messages.technicalDifficulties, messages.closeWindow);
            return false;
        } finally {
            hideProgressDialog();
        }
    }, [wasAnalyticsTriggered, isComponentValid, setCurrentStepName, submissionVM, setDefaultPrimaryPhone, uppercaseNames, _leadStartEvent, errorTimestamp, viewModelService, policyAddress, productCode, showProgressDialog, checkAvailability, currentStep.mlStepName, getPolicyTypeName, coverageType, translator, createBundleSubmissions, steps, changeNextSteps, hideProgressDialog, wizardSteps]); // eslint-disable-line react-hooks/exhaustive-deps
    
    const mailingAddresslookupVisibility = useCallback(() => {
        return !sameMailingAddressValue;
    }, [sameMailingAddressValue]);

    const sameMailingAddrForAddrLookup = useCallback(() => {
        return sameMailingAddressValue;
    }, [sameMailingAddressValue]);

    const updateMailingAddress = useCallback(() => {
        const flag = !sameMailingAddressValue;
        const clonedSubmissionVM = _.clone(submissionVM);
        _.set(clonedSubmissionVM, 'baseData.sameMailingAddress_ML.value', flag);
        if (flag) {
            syncAddresses(policyAddress, clonedSubmissionVM.baseData.mailingAddress_ML);
            syncAddresses(policyAddress, clonedSubmissionVM.baseData.sniPriorAddress_Ext);
        } else {
            clonedSubmissionVM.baseData.mailingAddress_ML = {};
        }
        updateWizardData(clonedSubmissionVM);
    }, [policyAddress, sameMailingAddressValue, submissionVM, updateWizardData]);

    const updatePriorAddress = useCallback(() => {
        const flag = !priorMailingAddressValue;
        const clonedSubmissionVM = _.clone(submissionVM);
        _.set(clonedSubmissionVM, 'baseData.priorAddressQuestion_Ext.value', flag);
        if (!flag) {
            syncAddresses(policyAddress, clonedSubmissionVM.baseData.priorAddress_Ext);
        } else {
            clonedSubmissionVM.baseData.priorAddress_Ext = {};
        }
        updateWizardData(clonedSubmissionVM);
    }, [policyAddress, priorMailingAddressValue, submissionVM, updateWizardData]);

    const isEmptyMailingAddress = mailingAddress?.value
        && typeof mailingAddress.value === 'object'
        && Object.keys(mailingAddress.value).length === 0;

    const hasValidMailingAddress = (address) => {
        if (!address || Object.keys(address).length === 0) {
            return false;
        }
        if (
            Object.keys(address).length === 1
            && address.country === 'US'
        ) {
            return false;
        }
        return true;
    };

    const isAddressMatch = isEmptyMailingAddress || !hasValidMailingAddress(mailingAddress?.value)
        ? true : MLWizardUtil.areAddressesEqual(mailingAddress?.value, policyAddress?.value);

    const isSupportedProduct = MLProductCodeUtil.isHomeOwners(productCode)
        || MLProductCodeUtil.isPersonalAuto(productCode)
        || MLProductCodeUtil.isPersonalUmbrella(productCode);

    const periodStartDateValue = _.get(submissionVM, 'baseData.periodStartDate.value')
        || _.get(submissionVM, 'value.baseData.periodStartDate');

    const isFutureEffectiveDate = periodStartDateValue?.year
        && new Date(
            periodStartDateValue.year,
            periodStartDateValue.month,
            periodStartDateValue.day
        ) > new Date();

    const isChangeMailingAddressQuestionVisible = () => {
        return isFutureEffectiveDate && isSupportedProduct && !isAddressMatch;
    };

    useEffect(() => {
        if (isChangeMailingAddressQuestionVisible() && _.isUndefined(changeMailingAddressValue)) {
            const clonedSubmissionVM = _.clone(submissionVM);
            _.set(clonedSubmissionVM, 'baseData.changeMailingAddQuestion_Ext.value', false);
            updateWizardData(clonedSubmissionVM);
        }
    }, [isFutureEffectiveDate, isSupportedProduct, isAddressMatch]);

    const updateChangeMailingAddress = useCallback((newValue) => {
        const clonedSubmissionVM = _.clone(submissionVM);
        _.set(clonedSubmissionVM, 'baseData.changeMailingAddQuestion_Ext.value', newValue);
        updateWizardData(clonedSubmissionVM);
    }, [submissionVM, updateWizardData]);

    const effectiveDateTooltip = useCallback(() => {
        if(isQuoteAndBuy){
            return messages.chooseExpirationDateOfExistingCoverageQb;
        }

        if (productCode === HOP_HOMEOWNERS) {
            if (coverageType === HOP_RENTAL) {
                return messages.hoprentalEffectiveDateTooltip;
            }

            return messages.hoEffectiveDateTooltip;
        }

        return messages.chooseExpirationDateOfExistingCoverage;
    }, [coverageType, productCode]);

    const getAddressLookupTooltipText = () => {
        if (productCode === HOP_HOMEOWNERS) {
            return messages.yourAddressHOTooltipText;
        }

        if (productCode === PERSONAL_AUTO) {
            return messages.yourAddressPATooltipText;
        }

        return messages.yourAddressPUPTooltipText;
    };

    // Click to Chat Integration
    const setChatData = () => {
        const chatData = {
            'FirstName': submissionVM.baseData.accountHolder.firstName.value,
            'LastName': submissionVM.baseData.accountHolder.lastName.value,
            'Contact_Name__c': `${submissionVM.baseData.accountHolder.firstName.value} ${submissionVM.baseData.accountHolder.lastName.value}`
        };
        MLClickToChatService.setChatData(chatData, 'QB');
    };

    const updateClickToChatFirstName = (value) => {
        writeValue(value, "baseData.accountHolder.firstName");
        writeValue(value, "baseData.primaryNamedInsured_ML.firstName");
        setChatData();
    };

    const updateClickToChatLastName = (value) => {
        writeValue(value, "baseData.accountHolder.lastName");
        writeValue(value, "baseData.primaryNamedInsured_ML.lastName");
        setChatData();
    };

    const emailTrim = (event) => {
        let emailAddress1 = event.target.value;
        if (emailAddress1 !== "" && emailAddress1 !== undefined) {
            emailAddress1 = emailAddress1.trim();
            event.target.value = emailAddress1;
        }
    }

    const onBlurEmailAddress = (evt) => {
        const target = evt.relatedTarget
        const accountContactDetailsVm = _.get(submissionVM, 'baseData.primaryNamedInsured_ML');
        validateEmailAddress(accountContactDetailsVm, target);
    };

    const validateEmailAddress = (accountContactDetailsVm, focusTarget) => {
        const account = accountContactDetailsVm;
        let emailAddress1 = _.get(account, 'emailAddress1.value');
        if (emailAddress1) {
            emailAddress1 = emailAddress1.trim();
        }
        let isValidEmailEntred = /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(emailAddress1)
        if (isValidEmailEntred) {
            const checkEmailVerified_Ext = EmailValidationService.checkEmailVerified_Ext(
                emailAddress1,
                authHeader
            );
            showProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
            checkEmailVerified_Ext.then((res) => {
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                if (res == true) {
                    _.set(account, 'emailVerified_Ext.value', true);
                    _.set(account, 'emailAddress1.value', emailAddress1);
                }
                else {
                    _.set(account, 'emailVerified_Ext.value', false);
                    _.set(account, 'emailAddress1.value', emailAddress1 + " ");
                }

                if (focusTarget) {
                    setTimeout(()=> { focusTarget.focus()}, 0)
                }
            }).catch((e) => {
                clearBlockAlerts('invalidEmail');
                addWarningAlert(translator(messages.invalidEmail), 'invalidEmail');
                _.set(account, 'emailVerified_Ext.value', false);
                _.set(account, 'emailAddress1.value', emailAddress1);
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                console.log(e);
                window.scrollTo(0, 0);
            });
        }

    };

    const isCompleteDate = (value) =>
        value &&
        value.day != null &&
        value.month != null &&
        value.year != null;

    const getSearchTooltipContent = () => {
        if (isQuoteAndBuy) {
            return messages.emailTooltipTextQb;
        }

        return messages.emailTooltipText;
    };

    const validateNoAlphaNumericCharacters = (name) => {
        return name && !/^[^0-9]+$/.test(name);
    };

    const getNameValidationMessage = (name) => {
        if (name && name?.value && validateNoAlphaNumericCharacters(name?.value)) {
            return [messages.noAlphaNumeric_ML];
        }

        return name?.aspects?.validationMessages;
    };

    const overrideProps = {
        addresslookup: {
            onValueChange: writeAddressValueML,
            sectionLabel: isQuoteAndBuy ? messages.policyAddrStreetLabel : productCode === HOP_HOMEOWNERS ? messages.propertyAddressLabel : messages.yourAddressLabel,
            tooltipTitle: translator(productCode === HOP_HOMEOWNERS ? messages.propertyAddressLabel : messages.yourAddressLabel),
            tooltipText: translator(getAddressLookupTooltipText()),
            initialLockStateCity: false,
            showValidationErrors: showErrors,
            value: _.get(submissionVM, 'baseData.policyAddress'),
            submissionVM,
            className: isQuoteAndBuy ? 'addressLookupQnB' : 'addressLookup',
            searchLabel: isQuoteAndBuy ? translator(messages.searchLabel) : translator(messages.policyAddrSearchLabel)
        },
        addSecondNamedInsured: {
            submissionVM,
            updateWizardData,
            samePhone,
            setSamePhone,
            namedInsuredCandidates: namedInsuredCandidatesML,
            onValidate,
            showValidationErrors: showErrors,
            validateEmailAddress,
            isModernProduct,
            pniPriorAddress: priorAddress,
        },
        phoneNumber: {
            updateContactVM: updateSubmissionVM,
            contactVM: submissionVM.baseData.primaryNamedInsured_ML,
            onValidate,
            showValidationErrors: showErrors,
            submissionVM,
            disabled: isQuoteAndBuy && (submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value')))
        },
        dobTooltipContainer: {
            className: isQuoteAndBuy ? "col-md-6" : "col-md-6 tooltipContainerOverride"
        },
        emailAddressTooltipContainer: {
            className: isQuoteAndBuy ? "col-md-6" : "col-md-6 tooltipContainerOverride"
        },
        coverageDateTooltipContainer: {
            className: isQuoteAndBuy ? "col-md-6" : "col-md-6 tooltipContainerOverride"
        },
        emailAddress: {
            ref: emailRef,
            onValueChange: (value, path) => {
                // HVQ quote may not have this required value
                if (submissionVM.baseData?.primaryNamedInsured_ML?.emailAddress1 &&
                    submissionVM.baseData?.primaryNamedInsured_ML?.accountHolder?.value === true) {
                    submissionVM.baseData.primaryNamedInsured_ML.emailAddress1.value = value;
                }
                writeValue(value, path);
            },
            onBlur: onBlurEmailAddress,
            onFocus: (event) => emailTrim(event),
            disabled: isQuoteAndBuy && (submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value')))
        },
        emailAddressTooltipComponent: {
            tooltipContent: getSearchTooltipContent()
        },
        mailingAddresslookup: {
            id: 'mailingAddresslookup',
            sameMailingAddress: sameMailingAddrForAddrLookup(),
            onValueChange: writeValue,
            initialLockStateCity: false,
            showValidationErrors: showErrors,
            addressLine1Placeholder: translator(messages.mailingAddrSearchLabel)
        },
        mailingAddressDetailsContainer: {
            visible: mailingAddresslookupVisibility()
        },
        mailingAddressRadioButton: {
            className: isQuoteAndBuy ? "radioButtonQnB" : "",
            onValueChange: updateMailingAddress
        },
        changeMailingAddressContainer: {
            visible: isChangeMailingAddressQuestionVisible()
        },
        changeMailingAddressRadioButton: {
            className: isQuoteAndBuy ? 'vertical-spacing-15 radioButtonQnB' : 'vertical-spacing-35',
            onValueChange: updateChangeMailingAddress,
            value: changeMailingAddressValue
        },
        priorAddressDetailsContainer: {
            visible: priorMailingAddressValue
        },
        priorAddressRadioButton: {
            onValueChange: updatePriorAddress,
            value: priorMailingAddressValue,
            className: isQuoteAndBuy ? "vertical-spacing-15 radioButtonQnB" : "vertical-spacing-35"
        },
        priorAddresslookup: {
            id: 'priorAddresslookup',
            onValueChange: writeValue,
            initialLockStateCity: false,
            value: priorAddress,
            showValidationErrors: showErrors
        },
        coverageDateTooltipComponent: {
            tooltipContent: translator(effectiveDateTooltip())
        },
        firstName: {
            ref: firstNameRef,
            onValueChange: updateClickToChatFirstName,
            validationMessages: getNameValidationMessage(_.get(submissionVM, 'baseData.primaryNamedInsured_ML.firstName')),
            disabled: isQuoteAndBuy && (submissionVM?.value?.hvqQuoteID_ML || submissionVM?.value?.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || (_.get(submissionVM, 'quoteData.paymentQuotes_ML.value'))),
            label: isQuoteAndBuy ? translator(messages.firstNameCommon) : translator(messages.nameCommon)
        },
        firstNameContainer: {
            className: isQuoteAndBuy ? "col-md-3-qb vertical-spacing-35 nameField nameFieldSpacing" : "col-md-3 vertical-spacing-35 nameField"
        },
        lastName: {
            ref: lastNameRef,
            onValueChange: updateClickToChatLastName,
            validationMessages: getNameValidationMessage(_.get(submissionVM, 'baseData.primaryNamedInsured_ML.lastName')),
            disabled: isQuoteAndBuy && (submissionVM?.value?.hvqQuoteID_ML || submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value'))),
            label: isQuoteAndBuy ? translator(messages.lastNameCommon) : translator(messages.blankCommon)
        },
        lastNameContainer: {
            className: isQuoteAndBuy ? "col-md-3-qb vertical-spacing-35 lastNameField nameFieldSpacing" : "col-md-3 vertical-spacing-35 no-label-top-spacing lastNameField"
        },
        middleName: {
            disabled: isQuoteAndBuy && (submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value')))
        },
        middleNameContainer: {
            visible: !isQuoteAndBuy
        },
        suffixContainer: {
            visible: !isQuoteAndBuy
        },
        dobFields: {
            className: isQuoteAndBuy ? "col-md-12" : "col-md-4"
        },
        emailAddressFieldContainer: {
            className: isQuoteAndBuy ? "col-md-12" : "col-md-4"
        },
        coverageDateField: {
            className: isQuoteAndBuy ? "col-md-12" : "col-md-4"
        },
        explicitConsentFirstContainer: {
            visible: isQuoteAndBuy
        },
        explicitConsentSecondContainer: {
            visible: isQuoteAndBuy
        },
        dateOfBirth: {
            disabled: isQuoteAndBuy && (submissionVM?.value?.hvqQuoteID_ML || submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value'))),
            ref: dateOfBirthRef,
            onValueChange: (value, path) => {
                writeValue(value, path);

                if (isCompleteDate(value)) {
                    setTimeout(() => {
                        const picker = dateOfBirthRef.current?.datePickerRef?.current;
                        if (picker?.isCalendarOpen?.()) {
                            picker.setOpen(false);
                        }
                    }, 0);
                }
            },
        },
        periodStartDate: {
            ref: periodStartDateRef,
            onValueChange: (value, path) => {
                writeValue(value, path);

                if (isCompleteDate(value)) {
                    setTimeout(() => {
                        const picker = periodStartDateRef.current?.datePickerRef?.current;
                        if (picker?.isCalendarOpen?.()) {
                            picker.setOpen(false);
                        }
                    }, 0);
                }
            },
        },
        suffix: {
            disabled: isQuoteAndBuy && (submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value')))
        },
        dobFieldContainer: {
            className: isQuoteAndBuy ? "row vertical-spacing-15" : "row vertical-spacing-30"
        },
        emailAddressContainer: {
            className: isQuoteAndBuy ? "row vertical-spacing-15" : "row vertical-spacing-30"
        },
        infoSpouseSSNCreditNP:{
            visible: isQuoteAndBuy && isModernProduct && productCode === PERSONAL_AUTO && _.get(submissionVM, 'value.baseData.policyAddress.state') === 'KS',
            className: isQuoteAndBuy ? "prefill-script-box bg-white" : "prefill-script-box"
        },
        informationLookupNotification: {
            className: isQuoteAndBuy ? "prefill-script-box bg-white" : "prefill-script-box"
        },
        informationHeaderContainerLink: {
            className: isQuoteAndBuy ? "custom-text-link-color" : ""
        },
        explicitConsent2: {
            className: isQuoteAndBuy ? "custom-text-link-color" : ""
        },
        explicitConsent5: {
            className: isQuoteAndBuy ? "custom-text-link-color" : ""
        },
        infoSpouseSSNCreditUT:{
            visible: isQuoteAndBuy && isModernProduct && productCode === PERSONAL_AUTO && _.get(submissionVM, 'value.baseData.policyAddress.state') === 'UT',
            className: isQuoteAndBuy ? "prefill-script-box bg-white" : "prefill-script-box"
        },
        infoSpouseSSNCreditState:{
            visible: isQuoteAndBuy && isModernProduct && productCode === PERSONAL_AUTO && ['AR', 'ND', 'SC', 'OR', 'CO', 'AZ', 'TX'].includes(state),
            content: state === 'OR' ? translator(messages.ssnMsgOrState) : state === 'TX' ? translator(messages.ssnMsgTxState) : translator(messages.ssnMsgOtherState)
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveClassNameMap: styles,
        resolveComponentMap: {
            mlPolicyNamedInsuredCandidatesComponent: MLPolicyNamedInsuredCandidatesComponent,
            secondaryNamedInsuredComponent: SecondaryNamedInsuredComponent,
            phoneNumberComponent: MLPhoneNumberComponent
        }
    };

    const renderPrivacyPolicy = () => (
        <PrivacyPolicyComponent />
    );

    const nextStepText = () => {
        if (productCode === PERSONAL_AUTO) {
            return (
                <FormattedMessage
                    {...messages.findemployerAndAffiliations}
                    values={{
                        employerAndAffiliations: (
                            <strong>{translator(messages.employerAndAffiliations)}</strong>
                        )
                    }}
                />
            );

        }

        return (
            <FormattedMessage
                {...messages.verifyEligibilityNext}
                values={{
                    verifyEligibility: (
                        <strong>{translator(messages.verifyEligibility)}</strong>
                    )
                }}
            />
        );
    };

    return (
        <WizardPage
            onNext={onNext}
            showPrevious={false}
            skipWhen={skipOnResumeIf}
            showCancel={false}
            nextLabel={isQuoteAndBuy ? translator(messages.agreeAndSubmit) : translator(messages.Continue)}
            showPrivacyPolicy
            renderPrivacyPolicyComponent={renderPrivacyPolicy}
            showTextNextToButton
            textNextToButton={nextStepText()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                showErrors={showErrors}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
}

YourInfoPage.propTypes = wizardProps;
export default YourInfoPage;